// Jost for the whole pre-login QRC subtree.
//
// The app theme already lists Jost first (see src/theme.ts) and index.html loads it, but that
// only covers MUI components that read typography from the theme — plain DOM nodes inherit from
// `body`, which sets no font-family, so they fall back to the browser default. Spreading this
// onto a page root pins Jost for everything inside it without touching the global theme.
export const JOST_FONT_STACK = "'Jost', 'Helvetica Neue', Arial, sans-serif";

export const preLoginFontSx = {
  fontFamily: JOST_FONT_STACK,
  "& *": { fontFamily: JOST_FONT_STACK },
} as const;
